import angular from 'angular';
import { exportTranslationsToCsv } from './translateExportSvc';

angular
  .module('cxTranslations')
  .controller('TranslateLabelsCtrl', [
    '$filter',
    'translateSvc',
    'flySvc',
    'localStorageService',
    translateLabelsCtrl,
  ]);

function translateLabelsCtrl($filter, translateSvc, flySvc, localStorageService) {
  var vm = this;
  vm.fNotTranslated = true;
  vm.fInvalidKeys = false;
  vm.showModifiedDates = false;
  vm.showScanInfo = false;
  vm.showDefaultValue = true;
  vm.loading = false;
  vm.languages = [];
  vm.allLanguages = [];
  vm.translations = [];
  vm.filteredTranslations = [];
  vm.pagedTranslations = [];
  vm.pageSize = 100;
  vm.pageSizeOptions = [50, 100, 200, 500];
  vm.currentPage = 1;
  vm.totalPages = 1;

  vm.selectedLanguages = localStorageService.get('TranslationToolLanguages') || ['nl'];

  vm.addLanguage = function(lang) {
    if (!lang) return;
    vm.selectedLanguages.push(lang);
    localStorageService.set('TranslationToolLanguages', vm.selectedLanguages);
    vm.filterLanguages();
    vm.getTranslations([lang]);
  };

  vm.removeLanguage = function(lang) {
    if (!lang) return;
    var idx = vm.selectedLanguages.indexOf(lang);
    if (idx >= 0) {
      vm.selectedLanguages.splice(idx, 1);
      localStorageService.set('TranslationToolLanguages', vm.selectedLanguages);
      vm.filterLanguages();
      vm.applyFilters();
    }
  };

  vm.applyFilters = function() {
    var filtered = vm.translations.filter(vm.filterTranslations);
    filtered = $filter('filter')(filtered, vm.search);
    filtered = $filter('orderBy')(filtered, vm.predicate, vm.reverse);
    vm.filteredTranslations = filtered;
    vm.totalPages = Math.max(1, Math.ceil(filtered.length / vm.pageSize));
    if (vm.currentPage > vm.totalPages) vm.currentPage = vm.totalPages;
    if (vm.currentPage < 1) vm.currentPage = 1;
    vm.updatePage();
  };

  vm.updatePage = function() {
    var start = (vm.currentPage - 1) * vm.pageSize;
    vm.pagedTranslations = vm.filteredTranslations.slice(start, start + vm.pageSize);
  };

  vm.setPage = function(page) {
    if (page < 1 || page > vm.totalPages) return;
    vm.currentPage = page;
    vm.updatePage();
  };

  vm.nextPage = function() {
    vm.setPage(vm.currentPage + 1);
  };

  vm.prevPage = function() {
    vm.setPage(vm.currentPage - 1);
  };

  vm.firstPage = function() {
    vm.setPage(1);
  };

  vm.lastPage = function() {
    vm.setPage(vm.totalPages);
  };

  vm.changePageSize = function() {
    vm.currentPage = 1;
    vm.applyFilters();
  };

  vm.onFilterChange = function() {
    vm.currentPage = 1;
    vm.applyFilters();
  };

  vm.filterLanguages = function() {
    vm.languages = vm.allLanguages.filter(function(lang) {
      return vm.selectedLanguages.indexOf(lang) < 0;
    });
  };
  vm.filterTranslations = function(item) {
    if (vm.showNotScanned) {
      if (item.source || item.lastScanned) return false;
    }
    if (vm.fInvalidKeys) {
      return vm.containsLineEnd(item.key);
    }
    if (vm.fNotTranslated) {
      for (var i = 0; i < vm.selectedLanguages.length; i++) {
        var trans = item[vm.selectedLanguages[i]];
        if (!trans) return false;
        if (!(trans.value || trans.inherited)) return true;
      }
      return false;
    }

    return true;
  };

  vm.getTranslations = function(languages) {
    if (!languages || !languages.length) return;
    vm.loading = true;
    return translateSvc.getLabels(languages).then(function(data) {
      if (vm.translations.length) {
        for (var i = 0; i < data.length; i++) {
          var group = data[i];
          var translation = vm.translations.find(function(x) {
            return x.key === group.key;
          });
          if (!translation) {
            translation = {
              key: group.key,
              lastScanned: group.lastScanned,
              source: group.source,
              defaultValue: group.defaultValue,
            };
            vm.translations.push(translation);
          }
          if (group.translations)
            //Map translation object directly onto parent object
            angular.extend(translation, group.translations);
        }
      } else {
        vm.translations = data.map(function(group) {
          var translation = {
            key: group.key,
            lastScanned: group.lastScanned,
            source: group.source,
            defaultValue: group.defaultValue,
          };

          if (group.translations)
            //Map translation object directly onto parent object
            angular.extend(translation, group.translations);

          return translation;
        });
      }
      vm.applyFilters();
      vm.loading = false;
    });
  };

  vm.reloadTranslations = function() {
    vm.translations = [];
    vm.getTranslations(vm.selectedLanguages);
  };

  vm.save = function(item, lang, value) {
    translateSvc.saveLabel(lang, item.key, value, 1);
  };

  vm.removeTranslation = function(item) {
    translateSvc.removeLabel(item.key, 1).then(function() {
      var idx = vm.translations.findIndex(function(x) {
        return x.key === item.key;
      });
      if (idx >= 0) vm.translations.splice(idx, 1);
      vm.applyFilters();
    });
  };
  vm.containsLineEnd = function(value) {
    if (!value || typeof value !== 'string') return false;
    return /\r|\n/.exec(value);
  };

  vm.coverage = function(item) {
    var covered = 0;
    for (var i = 0; i < vm.selectedLanguages.length; i++) {
      var t = item[vm.selectedLanguages[i]];
      if (t && (t.value || t.inherited)) covered++;
    }
    return covered;
  };

  vm.coverageClass = function(item) {
    var c = vm.coverage(item);
    var total = vm.selectedLanguages.length;
    if (c === 0) return 'label-danger';
    if (c < total) return 'label-warning';
    return 'label-success';
  };

  vm.exportToCsv = function() {
    exportTranslationsToCsv({
      translations: vm.filteredTranslations,
      selectedLanguages: vm.selectedLanguages,
      includeList: false,
      fileName: 'translations-labels-' + new Date().toISOString().slice(0, 10) + '.csv',
    });
  };

  vm.predicate = 'key';
  vm.reverse = false;
  vm.sort = function(predicate) {
    vm.reverse = vm.predicate === predicate ? !vm.reverse : false;
    vm.predicate = predicate;
    vm.applyFilters();
  };
  vm.allLanguages = translateSvc.languages;
  vm.filterLanguages();
  vm.reloadTranslations();
}
